import { render, staticRenderFns } from "./BatchForm.template.vue?vue&type=template&id=32d7f8e1&scoped=true&"
var script = {}
import style0 from "./BatchForm.template.vue?vue&type=style&index=0&id=32d7f8e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d7f8e1",
  null
  
)

export default component.exports